/*================ Backend Admin Routes===============*/

export const loginUrl = 'oauth/token';
export const location_url = 'location';

/*================ Backend Admin Routes ===============*/
/*================ Backend Customer Routes ===============*/

export const customer_login = 'customer/login';

export const frontDomain = process.env.FRONT_ROOT_URL;
export const ssoDomain = process.env.SSO_ROOT_URL;

export const autologinuser = 'http://vvg.parts.com/autologinuser';

/*================ Backend Customer Routes ===============*/



// WEBPACK FOOTER //
// ./src/config.js